<template>
  <div class="flex items-center justify-center min-h-[60vh] py-8 px-4">
    <div class="text-center max-w-sm w-full p-6">
      <svg class="w-12 h-12 mx-auto mb-4 text-red-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z"
        ></path>
      </svg>
      <h1 class="text-xl font-bold text-gray-900 mb-4">Authentication Failed</h1>
      <p class="text-gray-600 mb-6 text-sm">{{ errorMessage }}</p>
      <div class="space-y-3">
        <RouterLink
          to="login"
          class="block w-full bg-indigo-600 text-white px-4 py-2 rounded-md hover:bg-indigo-700 transition-colors duration-200 text-sm font-medium"
        >
          Try Again
        </RouterLink>
        <RouterLink
          to="registration"
          class="block w-full text-indigo-600 hover:text-indigo-500 transition-colors duration-200 text-sm font-medium"
        >
          Create New Account
        </RouterLink>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue'
import { useRoute } from 'vue-router'

const route = useRoute()
const errorMessage = ref('An unexpected error occurred during authentication.')

onMounted(() => {
  const error = route.query.error as string
  if (error) {
    errorMessage.value = decodeURIComponent(error)
  }
})
</script>
